/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import Loader from "Components/Common/Loader";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { Badge, Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import DigitalTableContainer from "../../Components/Common/DigitalTableContainer";
import { fetchMemoryItemsInFolderForTable } from "api/queries/file";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { SortingState } from "@tanstack/react-table";
import DeleteModal from "Components/Common/DeleteModal";
import { deleteBulkFile, requestSyncFiles, syncFiles, deleteKnowledgeBase } from "api/mutators/file";
import _, { set } from "lodash";
import * as yup from "yup";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import FilesFilter from "./FilesFilter";
import SyncModal from "./SyncModal";
import DeleteKBModal from "./DeleteKBModal";

import FileModal from "./FileModal";
import FolderModal from "./FolderModal";
import RequestSyncModal from "./RequestSyncModal";
import { getLoggedinUser } from "helpers/api_helper";
import ViewerModal from "./ViewerModal";
import { FileDtoItemTypeEnum } from "generated/apiFiles";
import VideoModal from "./VideoModal";

const FilesList = (props: any) => {
  const { t } = useTranslation("translation", { keyPrefix: "FILE_MANAGER" });
  const { folder, folderId, setActive, setActiveFile } = props;
  const queryClient = useQueryClient();
  const authUser: any = getLoggedinUser();

  const [search, setSearch] = useState<string>("");

  const [pageIndex, setPageIndex] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [sorting, setSorting] = useState<SortingState>([]);
  const [orderBy, setOrderBy] = useState<any[]>([]);

  const [pdfModal, setPdfModal] = React.useState(false);
  const [videoModal, setVideoModal] = React.useState(false);
  const [fileViewer, setFileViewer] = useState<any>(null);

  const [modal, setModal] = useState<boolean>(false);
  const [folderModal, setFolderModal] = useState<boolean>(false);
  const [requestSyncModal, setRequestSyncModal] = useState<boolean>(false);
  const [syncModal, setSyncModal] = useState<boolean>(false);
  const [deleteKBModal, setDeleteKBModal] = useState<boolean>(false);
  const [isMultiDeleteButton, setIsMultiDeleteButton] =
    useState<boolean>(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState<boolean>(false);

  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [isCheckedAll, setIsCheckedAll] = useState(false);

  // Files

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      //   setFile(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleFolder = useCallback(() => {
    if (folderModal) {
      setFolderModal(false);
      //   setFile(null);
    } else {
      setFolderModal(true);
    }
  }, [folderModal]);

  // Fetch files of folder clicked
  const { isPending, data, error, refetch } = useQuery<any>({
    queryKey: fetchMemoryItemsInFolderForTable.queryKey([
      search,
      { folderId, pageIndex, pageSize, orderBy },
    ]),
    queryFn: () =>
      fetchMemoryItemsInFolderForTable.queryFn({
        orderBy,
        take: pageSize,
        skip: pageIndex * pageSize,
        filter: {
          parentFolderId: folderId,
          search,
        },
      }),
  });

  useEffect(() => {
    if (data?.data && !isPending) {
      console.log("Data fetched: ", data.data);
    }
  }, [data, isPending]);

  const deleteMultiple = async () => {
    await mutation.mutate({ ids: selectedRows });
  };

  const toggleCheckAll = () => {
    const newCheckedState = !isCheckedAll;
    setIsCheckedAll(newCheckedState);
    setSelectedRows(
      newCheckedState && data?.data ? data?.data?.map((row: any) => row.id) : []
    ); // Seleziona o deseleziona tutto
    setIsMultiDeleteButton(!isCheckedAll);
  };

  // Funzione per gestire il toggle di una singola riga
  const toggleRowSelection = (id: number) => {
    if (selectedRows?.includes(id)) {
      if (selectedRows.length <= 1) setIsMultiDeleteButton(false);
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id)); // Deseleziona
    } else {
      setIsMultiDeleteButton(true);
      setSelectedRows([...selectedRows, id]); // Seleziona
    }
  };

  const handleValidDate = (date: any) => {
    const date1 = moment(new Date(date)).format("DD MMM Y");
    return date1;
  };

  const handleValidTime = (time: any) => {
    let orario = moment(new Date(time)).format("HH:mm");
    return orario;
  };

  const handleDoubleClick = (row: any) => {
    
    setFileViewer(row);

    if(row?.itemType === FileDtoItemTypeEnum.File) {
      setPdfModal(true);
    } else{
      setVideoModal(true);
    }
  };

  // Column
  const columns = [
    {
      header: (
        <input
          type="checkbox"
          id="checkBoxAll"
          className="form-check-input"
          checked={isCheckedAll}
          onChange={toggleCheckAll}
        />
      ),
      cell: (cell: any) => {
        return (
          <input
            type="checkbox"
            className="orderCheckBox form-check-input"
            checked={selectedRows.includes(cell.getValue())}
            onChange={() => toggleRowSelection(cell.getValue())}
          />
        );
      },
      id: "#",
      accessorKey: "id",
      enableColumnFilter: false,
      enableSorting: false,
    },
    {
      header: `${t("DETAILS:TABLE:TITLE")}`,
      accessorKey: "title",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <div className="table-fixed-column">{cell.getValue()}</div>
      ),
    },
    {
      header: `${t("DETAILS:TABLE:SIZE")}`,
      accessorKey: "size",
      enableColumnFilter: false,
      enableSorting: false,
      cell: (cell: any) => <>{ Number(Number(cell.getValue()) / 1024).toFixed(2) + " KB"}</>,
    },
    {
      header: `${t("DETAILS:TABLE:TYPE")}`,
      accessorKey: "type",
      enableColumnFilter: false,
      enableSorting: false,
      cell: (cell: any) => <>{ cell.getValue() == "folder" ? "Folder" : ( cell.getValue() == "video/mp4" ? "Video" : "Pdf" )}</>,
    },
    {
      header: `${t("DETAILS:TABLE:VIEW")}`,
      accessorKey: "view",
      enableColumnFilter: false,
      enableSorting: false,
      cell: (cell: any) => (
        <>
          <small>
            {cell.getValue() === "ALL" ? (
              <Badge color="info" className="ratingnum align-left">
                {t("DETAILS:TABLE:ALL")}
              </Badge>
            ) : cell.getValue() === "CAREGIVER_PROFESSIONAL" ? (
              <Badge color="danger" className="ratingnum align-middle">
                {t("DETAILS:TABLE:CAREGIVER_PROFESSIONAL")}
              </Badge>
            ) : cell.getValue() === "CAREGIVER_USER" ? (
              <Badge color="success" className="ratingnum align-middle">
                {t("DETAILS:TABLE:CAREGIVER_USER")}
              </Badge>
            ) : (
              <div>-</div>
            )}
          </small>
        </>
      ),
    },
    {
      header: `${t("DETAILS:TABLE:STATUS")}`,
      accessorKey: "status",
      enableColumnFilter: false,
      enableSorting: false,
      cell: (cell: any) => (
        <>
          <small>
            {cell.getValue() === "REFUSED" ? (
              <Badge color="info" className="ratingnum align-left">
                NOT CREATED
              </Badge>
            ) : cell.getValue() === "DIRTY" ? (
              <Badge color="danger" className="ratingnum align-middle">
                {cell.getValue()}
              </Badge>
            ) : cell.getValue() === "ACCEPTED" ? (
              <Badge color="success" className="ratingnum align-middle">
                {cell.getValue()}
              </Badge>
            ) : cell.getValue() === "WAITING" ? (
              <Badge color="warning" className="ratingnum align-middle">
                {cell.getValue()}
              </Badge>
            ) : (
              <div></div>
            )}
          </small>
        </>
      ),
    },
    {
      header: `${t("DETAILS:TABLE:CREATION_DATE")}`,
      accessorKey: "createdAt",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <>
          {handleValidDate(cell.getValue())},
          <small className="text-muted">
            {" "}
            {handleValidTime(cell.getValue())}
          </small>
        </>
      ),
    },
    {
      header: `${t("DETAILS:TABLE:ACTIONS")}`,
      cell: (cellProps: any) => {
        return (
          <ul className="list-inline hstack gap-2 mb-0">
            <li className="list-inline-item">
              <Link
                to="#"
                className="text-primary d-inline-block remove-item-btn"
                onClick={() => {
                  const fileData = cellProps.row.original;
                  setActive(true);
                  setActiveFile(fileData);
                }}
              >
                <i className="ri-eye-fill fs-16"></i>
              </Link>
            </li>
          </ul>
        );
      },
    },
  ];


  const columnsCargiver = [
    {
      header: `${t("DETAILS:TABLE:TITLE")}`,
      accessorKey: "title",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <div className="table-fixed-column">{cell.getValue()}</div>
      ),
    },
    {
      header: `${t("DETAILS:TABLE:SIZE")}`,
      accessorKey: "size",
      enableColumnFilter: false,
      enableSorting: false,
      cell: (cell: any) => <>{ Number(Number(cell.getValue()) / 1024).toFixed(2) + " KB"}</>,
    },
    {
      header: `${t("DETAILS:TABLE:TYPE")}`,
      accessorKey: "type",
      enableColumnFilter: false,
      enableSorting: false,
      cell: (cell: any) => <> { cell.getValue() == "folder" ? "Folder" : ( cell.getValue() == "video/mp4" ? "Video" : "Pdf" )}</>,
    },
    {
      header: `${t("DETAILS:TABLE:ACTIONS")}`,
      cell: (cellProps: any) => {
        return (
          <ul className="list-inline hstack gap-2 mb-0">
            <li className="list-inline-item">
              <Link
                to="#"
                className="text-primary d-inline-block remove-item-btn"
                onClick={() => {
                  const fileData = cellProps.row.original;
                  setActive(true);
                  setActiveFile(fileData);
                }}
              >
                <i className="ri-eye-fill fs-16"></i>
              </Link>
            </li>
          </ul>
        );
      },
    },
  ];



  const mutation = useMutation({
    mutationFn: deleteBulkFile,
    onError: (error: any) => {
      setIsMultiDeleteButton(false);

      queryClient.invalidateQueries({
        queryKey: ["fetchMemoryItemsInFolderForTable"],
      });
      queryClient.invalidateQueries({ queryKey: ["fetchMemoryItemsInFolder"] });
      toast.error("Error! Files not deleted", { autoClose: 3000 });
    },
    onSuccess: () => {
      setIsMultiDeleteButton(false);
      setSelectedRows([]);
      setIsCheckedAll(false);

      queryClient.invalidateQueries({
        queryKey: ["fetchMemoryItemsInFolderForTable"],
      });
      queryClient.invalidateQueries({ queryKey: ["fetchMemoryItemsInFolder"] });
      toast.success("Files Deleted Successfully", { autoClose: 3000 });
    },
  });


  const mutationRequestSync = useMutation({
    mutationFn: requestSyncFiles,
    onError: (error: any) => {
      queryClient.invalidateQueries({ queryKey: ["fetchMessagesNoRead"] });
      toast.error("Error! Request sync not emitted", { autoClose: 3000 });
    },
    onSuccess: (data: any) => {
      queryClient.invalidateQueries({ queryKey: ["fetchMessagesNoRead"] });
      toast.success(data?.data?.message, { autoClose: 3000 });
    },
  });

  const mutationSync = useMutation({
    mutationFn: syncFiles,
    onError: (error: any) => {
      queryClient.invalidateQueries({ queryKey: ["fetchMemoryItemsInFolder"] });
      queryClient.invalidateQueries({ queryKey: ["fetchMemoryItemsInFolderForTable"] });
      toast.error("Error! Request sync not emitted", { autoClose: 3000 });
    },
    onSuccess: (data: any) => {
      queryClient.invalidateQueries({ queryKey: ["fetchMemoryItemsInFolder"] });
      queryClient.invalidateQueries({ queryKey: ["fetchMemoryItemsInFolderForTable"] });
      toast.success(data?.data?.message, { autoClose: 3000 });
    },
  });

  const mutationDeleteKnowledgeBase = useMutation({
  mutationFn: deleteKnowledgeBase,
  onError: (error: any) => {
    queryClient.invalidateQueries({ queryKey: ["fetchMemoryItemsInFolder"] });
    queryClient.invalidateQueries({ queryKey: ["fetchMemoryItemsInFolderForTable"] });
    toast.error("Error! Delete Knowledge Base Failed", { autoClose: 3000 });
  },
  onSuccess: (data: any) => {
    queryClient.invalidateQueries({ queryKey: ["fetchMemoryItemsInFolder"] });
    queryClient.invalidateQueries({ queryKey: ["fetchMemoryItemsInFolderForTable"] });
    toast.success(data?.data?.message, { autoClose: 3000 });
  },
});


  const handleSync = () => {
    mutationSync.mutate();
    setSyncModal(false);
  };
  const handleDeleteKnowledgeBase = () => {
    mutationDeleteKnowledgeBase.mutate();
    setDeleteKBModal(false);
  };


  const handleRequestSync = () => {
    mutationRequestSync.mutate();
    setRequestSyncModal(false);
  };

  const schema = yup.object().shape({
    search: yup.string().required("Search is required"),
  });

  const defaultValues = {
    search: "",
  };

  const methods = useForm({
    defaultValues,
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const debounceFunction = useCallback(
    _.debounce((value) => {
      setSearch(value);
    }, 500),
    []
  );

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <RequestSyncModal
          show={requestSyncModal}
          onConfirmClick={handleRequestSync}
          onCloseClick={() => setRequestSyncModal(false)}
        />

        <SyncModal
          show={syncModal}
          onDeleteClick={handleSync}
          onCloseClick={() => setSyncModal(false)}
        />

        <DeleteKBModal
          show={deleteKBModal}
          onDeleteClick={handleDeleteKnowledgeBase}
          onCloseClick={() => setDeleteKBModal(false)}
        />

        <DeleteModal
          show={deleteModalMulti}
          onDeleteClick={() => {
            deleteMultiple();
            setDeleteModalMulti(false);
          }}
          onCloseClick={() => setDeleteModalMulti(false)}
        />

        <Row>
          <Col lg={12}>
            <Card id="museumFilesList">
              {folderId ? (
                <CardHeader className="card-header border-0">
                  <Row className="align-items-center gy-3">
                    <div className="col-sm">
                      <h5 className="card-title mb-0">
                        {t("LAYOUT:TITLE")} - {folder.name} -{" "}
                        {t(`DETAILS:TABLE:${folder.view || "ALL"}`)}
                      </h5>
                    </div>
                    <div className="col-sm-auto">
                      <div className="d-flex gap-1 flex-wrap">
                        {["SUPERADMIN", "MANAGER"].includes(authUser.role) && (
                          <>
                            <button
                              type="button"
                              className="btn btn-soft-danger add-btn"
                              id="create-folder-btn"
                              onClick={() => {
                                toggleFolder();
                              }}
                            >
                              <i className="ri-add-line align-bottom me-1"></i>
                              {t("LAYOUT:ADD_FOLDER")}
                            </button>{" "}
                            <button
                              type="button"
                              className="btn btn-soft-danger add-btn"
                              id="create-btn"
                              onClick={() => {
                                toggle();
                              }}
                            >
                              <i className="ri-add-line align-bottom me-1"></i>
                              {t("LAYOUT:ADD")}
                            </button>{" "}
                          </>
                        )}
                        {authUser?.role === "MANAGER" && (
                          <>
                            <button
                              type="button"
                              className="btn btn-soft-danger add-btn"
                              id="request-sync-btn"
                              onClick={() => {
                                setRequestSyncModal(true);
                              }}
                            >
                              <i className="ri-refresh-line align-bottom me-1"></i>
                              {t("LAYOUT:REQUEST_SYNC")}
                            </button>{" "}
                          </>
                        )}
                        {authUser?.role === "SUPERADMIN" && (
                          <>
                            <button
                              type="button"
                              className="btn btn-soft-danger add-btn"
                              id="sync-btn"
                              onClick={() => {
                                setSyncModal(true);
                              }}
                            >
                              <i className="ri-refresh-line align-bottom me-1"></i>
                              {t("LAYOUT:SYNC")}
                            </button>{" "}
                          <button
                              type="button"
                              className="btn btn-soft-danger add-btn"
                              id="delete-btn"
                              onClick={() => {
                                setDeleteKBModal(true);
                              }}
                            >
                              <i className="ri-delete-bin-line align-bottom me-1"></i>
                              {t("LAYOUT:DELETE_KB")}
                            </button>{" "}
                          </>
                        )}
                        {isMultiDeleteButton && (
                          <button
                            className="btn btn-soft-danger"
                            onClick={() => setDeleteModalMulti(true)}
                          >
                            <i className="ri-delete-bin-2-line"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </Row>
                </CardHeader>
              ) : (
                <div></div>
              )}

              {folderId ? (
                <FilesFilter debounceFn={debounceFunction} />
              ) : (
                <div></div>
              )}

              <CardBody className="pt-0">
                {folderId ? (
                  <div>
                    {!isPending && data?.data ? (
                      <DigitalTableContainer
                        columns={ authUser?.role === "SUPERADMIN" || authUser?.role === "MANAGER" ? columns : columnsCargiver }
                        data={data?.data || []}
                        numberOfRows={data?.count}
                        setPageIndex={setPageIndex}
                        setPageSize={setPageSize}
                        setSorting={setSorting}
                        pageSize={pageSize}
                        pageIndex={pageIndex}
                        sorting={sorting}
                        divClass="table-responsive table-card mb-1 mt-0"
                        tableClass="align-middle table-nowrap"
                        theadClass="table-light text-muted text-uppercase"
                        onRowDoubleClick={handleDoubleClick} 
                      />
                    ) : (
                      <Loader error={error} />
                    )}
                  </div>
                ) : (
                  <div style={{ fontWeight: "600", fontSize: "18px" }}>
                    {t("DETAILS:TITLE")}
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </FormProvider>

      <FileModal
        modal={modal}
        toggle={toggle}
        setModal={setModal}
        refetchFiles={refetch}
        folderId={folderId}
        folderView={folder.view}
      />

      <FolderModal
        modal={folderModal}
        toggle={toggleFolder}
        setModal={setFolderModal}
        refetchFiles={refetch}
        folderId={folderId}
        folderView={folder.view}
      />

      <ViewerModal
        setActive={setFileViewer}
        activeFile={fileViewer}
        setPdfModal={setPdfModal}
        pdfModal={pdfModal}
      />

      <VideoModal
        setActive={setFileViewer}
        activeFile={fileViewer}
        setVideoModal={setVideoModal}
        videoModal={videoModal}
      />
  </React.Fragment>
  );
};

export default FilesList;
